import { makeActionCreator } from '../../../../utilities'
import { HospitalNotifyConstants } from './hospitalNotify.constants'

export const setMethod = makeActionCreator(HospitalNotifyConstants.SET_METHOD, 'method')
export const setAlertType = makeActionCreator(HospitalNotifyConstants.SET_ALERT_TYPE, 'alertType')
export const setPotentialRegistry = makeActionCreator(
  HospitalNotifyConstants.SET_POTENTIAL_REGISTRY,
  'potentialRegistry'
)
export const saveHospitalNotify = makeActionCreator(HospitalNotifyConstants.SAVE_HOSPITAL_NOTIFY, 'data')
export const resetState = makeActionCreator(HospitalNotifyConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(HospitalNotifyConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(HospitalNotifyConstants.SET_STATE, 'hospitalNotifyState')
export const setDateTime = makeActionCreator(HospitalNotifyConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(HospitalNotifyConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectHospitalNotifyProcedure = makeActionCreator(HospitalNotifyConstants.ON_SELECT_HOSPITAL_NOTIFY)
export const setUpdateInputRows = makeActionCreator(HospitalNotifyConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(
  HospitalNotifyConstants.SET_SUCCESSFUL_ATTEMPT,
  'successfulAttempt'
)
export const setAttempts = makeActionCreator(HospitalNotifyConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(HospitalNotifyConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  HospitalNotifyConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  HospitalNotifyConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
